import {StyleSheet} from 'react-native';
import {fontFamily} from '../../helpers/fontFamily';

export const noticeTones = {
  warning: {background: '#fff3cd', text: '#664d03'},
  danger: {background: '#f8d7da', text: '#842029'},
  info: {background: '#cfe2ff', text: '#084298'},
};

export const noticeStyles = StyleSheet.create({
  banner: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    zIndex: 10,
    elevation: 10,
  },
  heading: {fontSize: 14, fontFamily: fontFamily.font600, marginBottom: 4},
  text: {fontSize: 14, fontFamily: fontFamily.font600},
  item: {fontSize: 13},
});
